import RecommendedItemApi from '@apis/item/RecommendedItemApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const recommendedItemQueries = createQueryKeys('recommendedItems', {
    main: () => ({
        queryKey: ['main'],
        queryFn: () => RecommendedItemApi.getMainRecommendedItems(),
    }),
    gift: (type: 'PRODUCT' |'CASH') => ({
        queryKey: ['gift', type],
        queryFn: () => RecommendedItemApi.getGiftRecommendedItems(type),
    }),
    shop: (shopId: string) => ({
        queryKey: ['shop', shopId],
        queryFn: () => RecommendedItemApi.getShopRecommendedItems(shopId),
    }),
});

export default recommendedItemQueries;
